let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8QvoP")).then(() => parcelRequire('ll8DE'));